module.exports = __webpack_public_path__ + "static/media/pathology_1.6dd564e5.jpeg";